import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "settlement-detail-audit"
};
const _hoisted_2 = {
  class: "contract-list-btn"
};
const _hoisted_3 = {
  style: {
    "margin-top": "10px"
  }
};
import apis from "@/api";
import { onMounted, reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import MonitorStatus from "../../AdvertLaunchMonitor/components/MonitorStatus.vue";
export default {
  __name: 'ContractComparison',
  props: {
    title: {
      type: String,
      default: '选择比对报告',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    contractCode: {
      type: String,
      default: '-1'
    }
  },
  emits: ['update:visible', 'select'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const data = reactive({
      queryParam: {
        monitorState: 9,
        contractCode: props.contractCode
      },
      tableData: [],
      selectData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      }
    });
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const emits = __emit;
    const elLoading = ref(false);
    onMounted(() => {
      loadData();
    });
    const loadData = () => {
      const params = {
        ...data.queryParam,
        ...data.pagination
      };
      elLoading.value = true;
      apis.pageByState(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        data.tableData = [];
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    // 预览附件
    const handleView = row => {
      window.open(row.fileUrl);
    };
    const handleSelect = () => {
      if (data.selectData.length === 0) {
        ElMessage.error('请选择比对结果');
      }
      emits('select', data.selectData);
      close();
    };
    const handleSelectionChange = val => {
      data.selectData = val;
    };
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const close = () => {
      emits('update:visible', false);
      data.selectData = [];
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "100%",
        fullscreen: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSelect
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("提交", -1)]))]),
          _: 1
        })])]), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: data.tableData,
          style: {
            "width": "100%"
          },
          "header-cell-style": headerStyle.value,
          onSelectionChange: handleSelectionChange,
          "empty-text": "",
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection"
          }), _createVNode(_component_el_table_column, {
            prop: "taskName",
            label: "任务名称"
          }), _createVNode(_component_el_table_column, {
            prop: "opCompany",
            label: "执行公司"
          }), _createVNode(_component_el_table_column, {
            prop: "opName",
            label: "执行人"
          }), _createVNode(_component_el_table_column, {
            prop: "fileName",
            label: "附件名称"
          }), _createVNode(_component_el_table_column, {
            prop: "monitorState",
            label: "监测状态"
          }, {
            default: _withCtx(scope => [_createVNode(MonitorStatus, {
              "monitor-state": scope.row.monitorState
            }, null, 8, ["monitor-state"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: $event => handleView(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("查看附件", -1)]))]),
              _: 1
            }, 8, ["onClick"])])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
          style: {
            "justify-content": "right"
          },
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "page-sizes": [10, 20, 50, 100, 200],
          "page-size": data.pagination.pageSize,
          total: data.pagination.totalSize,
          currentPage: data.pagination.pageNo,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => data.pagination.pageNo = $event),
          layout: "total, prev, pager, next, sizes, jumper"
        }, null, 8, ["page-size", "total", "currentPage"])])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};